import React from 'react'

//context
import { useContext, useState, useEffect } from 'react'
//character context
import { CharacterContext } from '../../../contexts/character'

//custom select
import Select from 'react-select'

//Job Ids
import * as jobID from '../../../data/jobID'

function BaseLevelSelect(props) {
	const { job, baseLevel, changeBaseLevel } = useContext(CharacterContext)

	const [minLevel, setMinLevel] = useState(Number(1))
	const [maxLevel, setMaxLevel] = useState(Number(99))
	const [options, setOptions] = useState([])
	const [selectedValue, setSelectedValue] = useState([
		{
			value: 1,
			label: 1,
			key: 'blv' + 1,
		},
	])

	useEffect(() => {
		if (
			job & jobID.EAJL_THIRD ||
			job === jobID.SOUL_REAPER ||
			job === jobID.STAR_EMPEROR ||
			job === jobID.KAGEROU ||
			job === jobID.OBORO ||
			job === jobID.REBELLION
		) {
			setMinLevel(Number(99))
			setMaxLevel(Number(200))
		} else {
			setMinLevel(Number(1))
			setMaxLevel(Number(99))
		}
		if (job === jobID.SUMMONER) {
			setMinLevel(Number(1))
			setMaxLevel(Number(200))
		}
	}, [job])
	useEffect(() => {
		let newOptions = []
		for (let i = minLevel; i <= maxLevel; i++) {
			newOptions.push({
				value: i,
				label: i,
				key: 'blv' + i,
				// isFixed: true,
			})
		}
		setOptions(newOptions)
	}, [minLevel, maxLevel])

	useEffect(() => {
		if (baseLevel > maxLevel || baseLevel < minLevel) {
			changeBaseLevel(99)
			setSelectedValue([
				{
					value: 99,
					label: 99,
					key: 'blv' + 99,
					// isFixed: true,
				},
			])
		}
		if (options.length > 0) {
			let newopt = options.find((opt) => opt.value === baseLevel)
			if (newopt) setSelectedValue(newopt)
			else {
				console.log('base level not found')
				setSelectedValue([
					{
						value: Number(1),
						label: Number(1),
						key: props.id + Number(1),
					},
				])
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [options])
	useEffect(() => {
		if (options.length > 0) {
			let newopt = options.find((opt) => opt.value === baseLevel)
			if (newopt) setSelectedValue(newopt)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [baseLevel, options])

	return (
		<div>
			<Select
				styles={props.customStyles}
				value={selectedValue}
				id={props.id}
				className={props.className}
				onChange={(event) => {
					changeBaseLevel(Number(event.value))
					setSelectedValue([
						{
							value: Number(event.value),
							label: Number(event.value),
							key: 'blv' + Number(event.value),
							// isFixed: true,
						},
					])
				}}
				options={options}
			/>
		</div>
	)
}

export default BaseLevelSelect
